/**
 * @voltxampere/ui — DB9 male RS-232 connector variant (Sprint 49-7)
 *
 * Standard 9-pin D-subminiature male connector for RS-232 serial
 * (PC COM port style). Pinout per EIA/TIA-574 (DTE convention):
 *
 *   1 DCD   (Carrier Detect)
 *   2 RXD   (Receive Data)
 *   3 TXD   (Transmit Data)
 *   4 DTR   (Data Terminal Ready)
 *   5 GND   (Signal Ground)
 *   6 DSR   (Data Set Ready)
 *   7 RTS   (Request To Send)
 *   8 CTS   (Clear To Send)
 *   9 RI    (Ring Indicator)
 *
 * Reference: EIA/TIA-574 (1990).
 *
 * Engine zero-diff invariant honored — schemaType `voltage-source`
 * (no MNA contribution; topological pin breakout).
 *
 * Copyright © 2026 360 Studio
 * Licensed under MIT (see LICENSE file in repo root)
 */
import { dcSource } from "../dc-source.js";
export const connectorDb9Male = {
    id: "db9-male",
    nameTr: "DB9 Erkek (RS-232 Konektör)",
    nameEn: "DB9 Male (RS-232 Connector)",
    shortcut: "J",
    category: "connector",
    viewBox: dcSource.viewBox,
    terminals: dcSource.terminals,
    defaultLabel: "J",
    defaultValue: "DB9-M",
    schemaType: "voltage-source",
    defaultParams: {
        voltage: 0,
        busType: "rs232-connector",
        pinCount: 9,
        pinout: {
            "1": "DCD",
            "2": "RXD",
            "3": "TXD",
            "4": "DTR",
            "5": "GND",
            "6": "DSR",
            "7": "RTS",
            "8": "CTS",
            "9": "RI",
        },
    },
    renderSVG: () => dcSource.renderSVG(),
};
//# sourceMappingURL=connector-db9-male.js.map